export enum RequestSource {
  INITIAL_INTAKE = "INITIAL_INTAKE",
  JOURNEY_CHANGE_INTAKE = "JOURNEY_CHANGE_INTAKE",
  DIRECT_REQUEST = "DIRECT_REQUEST",
  RENEWAL_INTAKE = "RENEWAL_INTAKE",
  RENEWAL_REPUBLISH = "RENEWAL_REPUBLISH",
  REJECTED_CARROT_PLAN = "REJECTED_CARROT_PLAN",
  ACKNOWLEDGED_CARROT_PLAN_POPUP = "ACKNOWLEDGED_CARROT_PLAN_POPUP",
  INCONCLUSIVE_BACKFILL = "INCONCLUSIVE_BACKFILL",
  CHECK_IN_INTAKE = "CHECK_IN_INTAKE"
}

export const getRequestSourceDisplayName = (requestSource: RequestSource): string => {
  switch (requestSource) {
    case RequestSource.INITIAL_INTAKE:
      return "Routing"
    case RequestSource.DIRECT_REQUEST:
      return "Admin generated"
    case RequestSource.JOURNEY_CHANGE_INTAKE:
      return "Journey change flow"
    case RequestSource.RENEWAL_INTAKE:
    case RequestSource.RENEWAL_REPUBLISH:
      return "Case rate renewal"
    case RequestSource.CHECK_IN_INTAKE:
      return "Check-in"
    default:
      return ""
  }
}
